import React, { useEffect, useState } from "react";
import PdfViewer from "../../PdfViewer/PdfViewer";
import moment from "moment";
import { iconData } from "../../../iconData";
import axios from "../../../axios";
import { useSelector } from "react-redux";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { IP } from "../../../internalServer";
import { Player } from "video-react";
import PreReadSuccess from "./PreReadSuccess";
// css comes from PreReadMain.css

// {setHomeMain, homeMain;}
export default function PendingSubDetails() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [responseAttach, setResponseAttach] = useState();
  const [isError, setIsError] = useState(false);
  const userId = useSelector((state) => state.user?.currentUser?.id);
  const [homeMain, setHomeMain] = useState({
    preReadData: null,
  });
  const [isGettingData, setIsGettingData] = useState(true);
  const [pedingSubDetail, setPedingSubDetail] = useState({
    pdfView: false,
    attachment: null,
  });
  const [allQuestion, setAllQuestion] = useState({
    sucessful: false,
  });

  const [isClicked, setIsClicked] = useState(false);
  const handleClick = (attachment) => {
    setResponseAttach(attachment);
    setIsClicked(!isClicked);
  };

  //  const [isPendingData, setIsPendingData] = useState({});
  //  const [detail, setDetail] = useState({
  //    attachment: null,
  //  });

  useEffect(() => {
    const pendingBox = async () => {
      try {
        let response = await axios.get(
          `homework/preRead/getById/${state.preReadId}`
        );

        response &&
          setHomeMain((prev) => ({ ...prev, preReadData: response.data.data }));
        setIsGettingData(false);
      } catch (error) {
        console.log(error);
      }
    };
    pendingBox();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRemovePdfVivwer = () => {
    setPedingSubDetail({
      ...pedingSubDetail,
      pdfView: false,
      attachment: null,
    });
  };

  const timeHelper = (a) => {
    const dateObj = new Date(a);
    const day = dateObj.getUTCDate().toString().padStart(2, "0");
    const month = (dateObj.getUTCMonth() + 1).toString().padStart(2, "0");
    const year = dateObj.getUTCFullYear();
    const hours = dateObj.getUTCHours();
    const minutes = dateObj.getUTCMinutes();
    const seconds = dateObj.getUTCSeconds();
    const outputDateString = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return outputDateString;
  };

  const handleMarkComplete = async () => {
    try {
      let res = await axios.post(
        `/homework/preReadId/${homeMain?.preReadData?.id}/studentPreRead/updateStatus/studentId/${userId}`,
        {
          status: "completed",
        }
      );
      res && setAllQuestion({ ...allQuestion, sucessful: true });
    } catch (error) {
      console.log(error);
    }
  };
  let From = localStorage.getItem("From");
  return (
    <div>
      {homeMain.preReadData ? (
        <div className="overAllContainer">
          <div className="d-flex align-items-center gap-2">
            <div
              className="d-flex align-items-center"
              style={{ cursor: "pointer" }}
              onClick={() => {
                From === "DCM" ? navigate("/Calender") : window.history.back();
              }}
            >
              <img src="/HwImg/BackArrow2.png" alt="" />
            </div>
            <div
              className="PrereadPath"
              style={{ cursor: "pointer" }}
              onClick={() => window.history.back()}
            >
              Pre-read
            </div>
            <div>/</div>
            <div className="chapterHeaderNamePath">
              {homeMain?.preReadData?.subject_id?.name} &nbsp;
              {homeMain?.preReadData?.chapter_id?.name}
            </div>
          </div>

          <div className="d-flex justify-content-between mt-3">
            <div className="SubHeaderPreRed">
              {homeMain?.preReadData?.subject_id?.name} &nbsp;
              {homeMain?.preReadData?.chapter_id?.name}
            </div>
            <div>
              <button onClick={handleMarkComplete} className="ButtonMarkCompl">
                Mark Completed
              </button>
            </div>
          </div>
          <div className="PrereadPath">
            {homeMain?.preReadData?.subject_id?.name}
          </div>
          <div className="SubDetailTextPreRead mt-4">
            {homeMain?.preReadData?.description}
          </div>

          <div>
            <div className="d-flex gap-3 mt-4 flex-wrap">
              {homeMain?.preReadData?.attachments?.map((attachment, index) => (
                // <div
                //   key={index}
                //   className="ContainerUploadedPdf d-flex gap-2 p-3"
                //   onClick={(e) =>
                //     setPedingSubDetail({
                //       ...pedingSubDetail,
                //       pdfView: true,
                //       attachment: attachment,
                //     })
                //   }
                // >
                //   <div className="d-flex align-items-center">
                //     <img
                //       className="extention_icon"
                //       src={`${
                //         iconData?.find(
                //           (i) =>
                //             i.extension === attachment?.match(/\.([^.]+)$/)[1]
                //         )?.icon
                //       }`}
                //       alt=""
                //     />
                //   </div>
                //   <div>
                //     <div className="pdfSub">
                //       {homeMain?.preReadData?.subject_id?.name}
                //     </div>
                //     <div className="ChapterNamePdf">
                //       {/* {homeMain?.preReadData?.chapter_id?.name} */}
                //       {attachment?.replace(/^[^_]*_/, "")}
                //     </div>
                //     <div className="timePdf">
                //       {moment(
                //         timeHelper(homeMain?.preReadData?.deadline)
                //       ).format("hh:mm a")}
                //     </div>
                //   </div>
                // </div>
                <div key={index}>
                  {attachment.split(".").pop() !== "mp4" ? (
                    <>
                      {attachment.split(".").pop() === "jpg" ||
                      attachment.split(".").pop() === "jpeg" ||
                      attachment.split(".").pop() === "JPEG" ||
                      attachment.split(".").pop() === "JPG" ||
                      attachment.split(".").pop() === "PNG" ||
                      attachment.split(".").pop() === "png" ? (
                        <div
                          key={index}
                          className="ContainerUploadedPdf d-flex gap-2 p-3"
                          onClick={() => {
                            if (!isError) {
                              handleClick(attachment);
                            }
                          }}
                        >
                          <div className="d-flex align-items-center">
                            <img
                              className="extention_icon"
                              src={`${
                                iconData?.find(
                                  (i) =>
                                    i.extension ===
                                    attachment?.match(/\.([^.]+)$/)[1]
                                )?.icon
                              }`}
                              alt=""
                            />
                          </div>
                          <div>
                            <div className="pdfSub">
                              {homeMain?.preReadData?.subject_id?.name}
                            </div>
                            <div className="ChapterNamePdf">
                              {/* {homeMain?.preReadData?.chapter_id?.name} */}
                              {attachment?.replace(/^[^_]*_/, "")}
                            </div>
                            <div className="timePdf">
                              {moment(homeMain?.preReadData?.updated_at)
                                .local()
                                .format("hh:mm a")}
                            </div>
                          </div>
                        </div>
                      ) : (
                        // <img
                        //   style={{ cursor: "pointer" }}
                        //   className="mt-3 imageWidthAndHeight"
                        //   src={IP + attachment?.replace(/^\./, "")}
                        //   alt="Thumbnail"
                        //   onClick={() => handleClick(attachment)}
                        // />
                        <div
                          key={index}
                          onClick={(e) => {
                            if (attachment.split(".").pop() === "mp3") {
                              handleClick(attachment);
                            } else {
                              setPedingSubDetail({
                                ...pedingSubDetail,
                                pdfView: true,
                                attachment: attachment,
                              });
                            }
                          }}
                          className="mt-2"
                        >
                          <div className="d-flex pdfContainer gap-2 p-2 ">
                            <div className="d-flex align-items-center">
                              <img
                                className="extention_icon"
                                src={`${
                                  iconData?.find(
                                    (i) =>
                                      i.extension ===
                                      attachment?.match(/\.([^.]+)$/)[1]
                                  )?.icon
                                }`}
                                alt=""
                              />
                            </div>
                            <div className="w-100">
                              <div className="pdfSub">
                                {homeMain?.preReadData?.subject_id?.name}
                              </div>
                              <div className="pdfName">
                                {attachment?.replace(/^[^_]*_/, "")}
                              </div>
                              <div className="pdfFileSize">
                                {moment(
                                  // timeHelper(
                                  homeMain?.preReadData?.updated_at
                                  // )
                                )
                                  .local()
                                  .format("hh:mm a")}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  ) : (
                    <div
                      className="d-flex pdfContainer gap-2 p-2 "
                      onClick={() => {
                        if (!isError) {
                          handleClick(attachment);
                        }
                      }}
                    >
                      <div className="d-flex align-items-center">
                        <img
                          className="extention_icon"
                          src={`${
                            iconData?.find(
                              (i) =>
                                i.extension ===
                                attachment?.match(/\.([^.]+)$/)[1]
                            )?.icon
                          }`}
                          alt=""
                        />
                      </div>
                      <div className="w-100">
                        <div className="pdfSub">
                          {homeMain?.preReadData?.subject_id?.name}
                        </div>
                        <div className="pdfName">
                          {attachment?.replace(/^[^_]*_/, "")}
                        </div>
                        <div className="pdfFileSize">
                          {moment(
                            // timeHelper(
                            homeMain?.preReadData?.updated_at
                            // )
                          )
                            .local()
                            .format("hh:mm a")}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ))}

              {/* <div className="ContainerUploadedPdf d-flex gap-2 p-3">
                  <div className="d-flex align-items-center">
                    <img src="/HwImg/WordIcon.png" alt="" />
                  </div>
                  <div>
                    <div className="pdfSub">English</div>
                    <div className="ChapterNamePdf">Chapter 1 explaination</div>
                    <div className="timePdf">10:30 AM</div>
                  </div>
                </div> */}
            </div>
          </div>

          {pedingSubDetail.pdfView && (
            <PdfViewer
              handleRemovePdfVivwer={handleRemovePdfVivwer}
              attachment={pedingSubDetail?.attachment}
            />
          )}

          {allQuestion.sucessful && <PreReadSuccess />}
        </div>
      ) : isGettingData ? (
        <img className="ongoing_loader" src="/gif/LoaderDot.gif" alt="" />
      ) : (
        <div className="d-flex justify-content-center h-20 align-items-center w-100">
          <span
            className="badge bg-light text-dark  rounded-pill px-4 py-3"
            style={{ fontSize: "1.2rem", letterSpacing: "0.5px" }}
          >
            📭 Pre-Read Not Found
          </span>
        </div>
      )}
      {isClicked &&
        (responseAttach.split(".").pop() === "mp4" ||
        responseAttach.split(".").pop() === "MP4" ? (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              <video className="videoPlayer" controls>
                <source
                  src={IP + responseAttach.replace(/^\./, "")}
                  type="video/mp4"
                />
              </video>
              <div>
                <img
                  className="crossIconImgQue"
                  onClick={handleClick}
                  src="/DCM-img/crossIcon.svg"
                  alt="Up Arrow"
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              {!isError ? (
                <>
                  <img
                    className="imgMain"
                    src={IP + responseAttach?.replace(/^\./, "")}
                    alt="Full-size"
                    onError={(e) => {
                      setIsError(true);
                    }}
                  />
                  <div>
                    <img
                      className="crossIconImgQue"
                      onClick={handleClick}
                      src="/images/cross.png"
                      alt="Up Arrow"
                    />
                  </div>
                </>
              ) : (
                <div
                  className="fullSizeImg"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <img
                    onClick={() => {
                      setIsError(false);
                      handleClick();
                    }}
                    src="/images/cross.png"
                    alt="Up Arrow"
                    style={{ position: "absolute", top: "75px", right: "40%" }}
                  />
                  <img
                    src="/images/no-photo1.png"
                    alt="img"
                    style={{ width: "25%" }}
                  />
                  <p
                    style={{
                      color: "red",
                      fontSize: "20px",
                      fontWeight: "500",
                      marginRight: "35px",
                    }}
                  >
                    Error!! failed to load the requested file!
                  </p>
                </div>
              )}
            </div>
          </div>
        ))}
    </div>
  );
}
